module.exports = __webpack_public_path__ + "static/media/pg22.2f154464.jpg";